import { FC, useContext, useEffect, useState } from "react";
import {
    IExcludePermissionFunction,
    IExcludePermissionFunctionFunctionGroups,
} from "../../../models/PermissionModels/IExcludePermissionFunction";
import { Context } from "../../../index";
import "./ProjectEditRoleBoard.css";
import { useParams } from "react-router-dom";
import { AppContext } from "../../../App";
import { IGetAllUsersWithSystemRolesChecked } from "../../../models/PersonModels/IGetAllUsersWithSystemRolesChecked";
import { initials } from "../../../helpers/Inicials";
import ParticipantRights from "../../Shared/ParticipantRights/ParticipantRights";
import { ItemPersonRole } from "../../../models/PersonModels/ItemPersonRole";
import { IRestrictBoard } from "../../../common/api_interfaces/board/IRestrictBoard";
import { IRestrictBoardView } from "../../../common/api_interfaces/board/IRestrictBoardView";
import { IExcludePermission } from "../../../common/api_interfaces/role/IExcludePermission";

interface IProjectEditRoleBoard {
    personRole: ItemPersonRole | null | undefined;
    closeFunc: () => void;
    roleEdit?: IExcludePermissionFunction | undefined;
    projectId: number | null | undefined;
}

const ProjectEditRoleBoard: FC<IProjectEditRoleBoard> = ({ personRole, closeFunc, roleEdit, projectId }) => {
    const { store } = useContext(Context);
    const [userRole, setUserRole] = useState<IExcludePermissionFunction | undefined>();
    const [page, setPage] = useState<boolean>(true);
    const roleIdG = roleEdit?.roles.findIndex((role) => role.personRoleId === personRole!.personRoleId)!;
    const [boardsData, setBoardsData] = useState<IRestrictBoardView>();
    const { id } = useParams();
    const { showToast } = useContext(AppContext);

    function onCheckEvent(id: number) {
        let boardIndex = boardsData?.boards.findIndex((board) => board.id === id)!;
        let chekIn = boardsData?.boards[boardIndex].personRoleIds?.includes(userRole!.roles[roleIdG].personRoleId);

        if (chekIn) {
            let data = boardsData?.boards.map((xx) => {
                if (xx.id === id) {
                    xx.personRoleIds = xx.personRoleIds?.filter((yy) => yy !== userRole!.roles[roleIdG].personRoleId);
                    xx.columns = xx.columns.map((zz) => {
                        zz.personRoleIds = zz.personRoleIds?.filter(
                            (yy) => yy !== userRole!.roles[roleIdG].personRoleId
                        );
                        return zz;
                    });
                }
                return xx;
            });
            let newData: IRestrictBoardView = JSON.parse(JSON.stringify(boardsData));
            newData.boards = data!;
            setBoardsData(newData);
        } else {
            let newData: IRestrictBoardView = JSON.parse(JSON.stringify(boardsData));
            if (newData.boards.find((xx) => xx.id === id)?.personRoleIds === undefined) {
                newData.boards[newData.boards.findIndex((board) => board.id === id)].personRoleIds!.push(
                    userRole!.roles[roleIdG].personRoleId
                );
                newData.boards[newData.boards.findIndex((board) => board.id === id)].columns = newData.boards[
                    newData.boards.findIndex((board) => board.id === id)
                ].columns.map((col) => {
                    if (!col.personRoleIds) {
                        col.personRoleIds = [];
                    }

                    col.personRoleIds = [...col.personRoleIds, userRole!.roles[roleIdG].personRoleId];
                    return col;
                });
            } else {
                newData.boards[newData.boards.findIndex((board) => board.id === id)].personRoleIds!.push(
                    userRole!.roles[roleIdG].personRoleId
                );
                newData.boards[newData.boards.findIndex((board) => board.id === id)].columns = newData.boards[
                    newData.boards.findIndex((board) => board.id === id)
                ].columns.map((col) => {
                    if (!col.personRoleIds) {
                        col.personRoleIds = [];
                    }

                    col.personRoleIds = [...col.personRoleIds, userRole!.roles[roleIdG].personRoleId];
                    return col;
                });
            }
            setBoardsData(newData);
        }
    }

    function saveExclude() {
        let allChoosePerm = userRole!.roles[roleIdG].excludedPermissions.map((xx) => xx.accessPermission);

        const data: IExcludePermission = {
            projectId: Number(id),
            personRoleId: userRole!.roles[roleIdG].personRoleId,
            accessPermissionIds: allChoosePerm,
        };

        let currentPersonRoleId = userRole!.roles[roleIdG].personRoleId;

        let restrict: IRestrictBoard = {
            personRoleId: currentPersonRoleId,
            boards: boardsData
                ? boardsData.boards.map((board) => ({
                      id: board.id,
                      restricted:
                          board.personRoleIds !== undefined && board.personRoleIds?.includes(currentPersonRoleId),
                      columns: board.columns.map((column) => ({
                          id: column.id,
                          restricted:
                              column.personRoleIds !== undefined && column.personRoleIds.includes(currentPersonRoleId),
                      })),
                  }))
                : [],
            projectId: Number(id),
        };

        (async () => {
            try {
                if (restrict) {
                    await store.saveRestrict(restrict);
                }
                if (data) {
                    await store.saveExcludeAccessPermission(data);
                }
                closeFunc();
            } catch (err) {
                console.log(err);
            }
        })();
    }

    function changeTab() {
        let allSystemFunction = userRole?.roles[roleIdG].functionGroups.flatMap((xx) => xx.systemFunctions);
        let findBoardAccess = allSystemFunction?.find((xx) => xx.functionCode === "BoardAction");
        let findViewBoard = findBoardAccess?.accessPermissions.find((yy) => yy.code === "view");
        let allExcludePerm = userRole?.roles[roleIdG].excludedPermissions.map((xx) => xx.accessPermission);

        if (findViewBoard === undefined) {
            showToast("Пользователю не выдан доступ на просмотр доски!");
            return;
        }

        if (allExcludePerm?.includes(findViewBoard.id)) {
            showToast("Пользователю не выдан доступ на просмотр доски!");
            return;
        }

        setPage(!page);
    }

    function getUsers() {
        const dataRoleEdit = roleEdit;
        (async () => {
            try {
                if (!dataRoleEdit) {
                    return;
                }

                let nowRoleEdit = dataRoleEdit?.roles[roleIdG];
                let systemRoleId = dataRoleEdit.roles.find((r) => r.systemRole === true)?.personRoleId;
                let systemRoleFind = dataRoleEdit.roles.find((role) => role.personRoleId === systemRoleId);

                if (!systemRoleFind) {
                    return;
                }

                let systemGroup = systemRoleFind!.functionGroups;
                let systemFunc = systemGroup
                    .flatMap((xx) => xx.systemFunctions)
                    .filter((xx) => xx.accessPermissions.length);
                let newRoleGroups = nowRoleEdit.functionGroups.map((projGroup) => {
                    if (systemGroup.map((xx) => xx.id).includes(projGroup.id)) {
                        projGroup.systemRole = true;
                        projGroup.systemFunctions = projGroup.systemFunctions.filter(
                            (xx) => xx.accessPermissions.length
                        );
                        projGroup.systemFunctions = projGroup.systemFunctions.map((projFunc) => {
                            if (systemFunc.map((xx) => xx.id).includes(projFunc.id)) {
                                projFunc.systemRole = true;

                                let sysFindFunc = systemFunc.find((xx) => xx.functionCode === projFunc.functionCode);

                                projFunc.accessPermissions = projFunc.accessPermissions.map((permission) => {
                                    if (
                                        sysFindFunc &&
                                        sysFindFunc.accessPermissions.map((xx) => xx.code).includes(permission.code)
                                    ) {
                                        permission.systemRole = true;
                                    } else {
                                        permission.systemRole = false;
                                    }

                                    return permission;
                                });

                                sysFindFunc &&
                                    sysFindFunc.accessPermissions?.forEach((perm) => {
                                        if (!projFunc.accessPermissions.some((p) => p.code === perm.code)) {
                                            projFunc.accessPermissions.push({
                                                id: perm.id,
                                                systemRole: true,
                                                code: perm.code as "view" | "create" | "delete" | "edit" | "full",
                                            });
                                        }
                                    });

                                return projFunc;
                            }

                            projFunc.systemRole = false;
                            return projFunc;
                        });

                        return projGroup;
                    }

                    return projGroup;
                });

                // Добавляем группы из системной роли которых не хватает в проеоктной роли
                systemGroup?.forEach((group) => {
                    if (!newRoleGroups.some((p) => p.id === group.id)) {
                        newRoleGroups.push({
                            id: group.id,
                            name: group.name,
                            systemRole: true,
                            systemFunctions:
                                group.systemFunctions?.map((func) => {
                                    if (func) {
                                        func.systemRole = true;
                                        func.accessPermissions =
                                            func.accessPermissions?.map((access) => {
                                                if (access) {
                                                    access.systemRole = true;
                                                    return access;
                                                }
                                                return access;
                                            }) || [];
                                        return func;
                                    }
                                    return func;
                                }) || [],
                        });
                    }
                });

                // Добавляем функции из системной роли, которых не хватает в проектной роли
                newRoleGroups.forEach((newRoleGroup) => {
                    const sameSystemGroup = systemGroup.find((g) => g.id === newRoleGroup.id);
                    if (!sameSystemGroup) return;
                    const missingFunctions = sameSystemGroup.systemFunctions.filter(
                        (systemFunc) =>
                            !newRoleGroup.systemFunctions.some((newRoleFunc) => systemFunc.id === newRoleFunc.id)
                    );
                    newRoleGroup.systemFunctions.push(...missingFunctions.map(f => ({
                        ...f,
                        accessPermissions: f.accessPermissions.map(a => ({...a, systemRole: true })),
                        systemRole: true
                    })))
                });

                dataRoleEdit.roles[roleIdG].functionGroups = newRoleGroups;

                if (
                    dataRoleEdit &&
                    dataRoleEdit.roles &&
                    dataRoleEdit.roles[roleIdG] &&
                    dataRoleEdit.roles[roleIdG].functionGroups
                ) {
                    const functionGroups = dataRoleEdit.roles[roleIdG].functionGroups;
                    const sortedFunctionGroups: IExcludePermissionFunctionFunctionGroups[] = [...functionGroups].sort(
                        sortFunctionGroups
                    );

                    dataRoleEdit.roles[roleIdG].functionGroups = sortedFunctionGroups;

                    setUserRole(dataRoleEdit);
                }
            } catch (err) {
                console.log(err);
            }
        })();
    }

    function addColumnAccess(columnId: number, addChek: boolean) {
        let findCurrentBoard = boardsData?.boards.find((xx) => xx.columns.some((xx) => xx.id === columnId));

        let newBoardStatus: IRestrictBoardView = JSON.parse(JSON.stringify(boardsData));

        let currentPersonRoleId = roleEdit!.roles[roleIdG]!.personRoleId;

        if (findCurrentBoard?.personRoleIds?.includes(currentPersonRoleId)) {
            showToast("Пользователь не добавлен на канбан доску!");
            return;
        }

        newBoardStatus.boards = newBoardStatus?.boards.map((xx) => {
            if (xx.id === findCurrentBoard?.id) {
                let findColumn = xx.columns.findIndex((yy) => yy && yy.id === columnId);
                if (
                    findColumn !== -1 &&
                    addChek === true &&
                    xx.columns[findColumn!].personRoleIds?.length &&
                    xx.columns[findColumn!].personRoleIds?.includes(currentPersonRoleId)
                ) {
                    let newPersonRole = xx.columns[findColumn!].personRoleIds?.filter(
                        (roleId) => roleId !== currentPersonRoleId
                    );
                    // let newPersonRole = xx.columns[findColumn!].personRoleIds.filter(roleId => roleId !== currentPersonRoleId);
                    xx.columns[findColumn!].personRoleIds = newPersonRole !== undefined ? newPersonRole : [];
                } else {
                    xx.columns[findColumn].personRoleIds?.push(currentPersonRoleId);
                }

                return xx;
            }

            return xx;
        });

        setBoardsData(newBoardStatus);
    }

    // function setNewStatusBoard() {
    //     let newBoardStatus: IRestrictBoardView = JSON.parse(JSON.stringify(boardsData));

    //     newBoardStatus.boards = newBoardStatus.boards.map((board) => {
    //         if (board.id === boardsSaveId?.board) {
    //             board.personRoleIds?.push(roleEdit!.roles[roleIdG]!.personRoleId);
    //             board.columns = board.columns.map((column) => {
    //                 if (column.id === boardsSaveId.column) {
    //                     column.selected = true;
    //                     column.personRoleIds?.push(roleEdit!.roles[roleIdG]!.personRoleId);
    //                     return column;
    //                 } else {
    //                     return column;
    //                 }
    //             });
    //             return board;
    //         } else {
    //             return board;
    //         }
    //     });

    //     setBoardsData(newBoardStatus);

    //     setViewWarning(false);
    // }

    useEffect(() => {}, [personRole]);

    useEffect(() => {
        const data: IExcludePermissionFunction | undefined = roleEdit;

        if (data && data.roles && data.roles[roleIdG] && data.roles[roleIdG].functionGroups) {
            const functionGroups = data.roles[roleIdG].functionGroups;
            const sortedFunctionGroups: IExcludePermissionFunctionFunctionGroups[] = [...functionGroups].sort(
                sortFunctionGroups
            );

            data.roles[roleIdG].functionGroups = sortedFunctionGroups;

            setUserRole(data);
        }
    }, [roleEdit]);

    function sortFunctionGroups(
        a: IExcludePermissionFunctionFunctionGroups,
        b: IExcludePermissionFunctionFunctionGroups
    ): number {
        const order = ["Проект", "Доска", "Задача", "Система"];
        const indexA = order.indexOf(a.name);
        const indexB = order.indexOf(b.name);
        return indexA - indexB;
    }

    function checkSystemRole(): boolean {
        const findSystemId = roleEdit?.roles.find((xx) => xx.systemRole === true);

        if (findSystemId) {
            let systemFunc = findSystemId.functionGroups.flatMap((xx) => xx.systemFunctions);
            let findFunctionCode = systemFunc.find((xx) => xx.functionCode === "BoardAction");
            let findPermission = findFunctionCode?.accessPermissions.find((xx) => xx.code === "view");
            let chekPermission = findSystemId.excludedPermissions.find((xx) => xx.id === findPermission?.id);

            if (findPermission && chekPermission === undefined) {
                return true;
            } else {
                return false;
            }
        }

        return false;
    }

    useEffect(() => {
        (async () => {
            try {
                getUsers();

                if (projectId) {
                    const boardData = await store.restrictAccess(projectId);
                    setBoardsData(boardData);
                }
            } catch (err) {
                console.log(err);
            }
        })();
    }, [roleEdit]);

    return (
        <div className="project__edit--role__board--component">
            <div className="project__edit--role__board--component__in">
                <div className="project__edit--role__board--component__role">
                    {initials(`${personRole?.name}`)} - {userRole?.roles[roleIdG].roleName}
                </div>
                <div className="project__edit--role__board--component__tab">
                    <div
                        className={`project__edit--role__board--component__head ${
                            page ? "project__edit--role__board--component__head--choise" : ""
                        }`}
                        onClick={changeTab}
                    >
                        Права участника
                    </div>
                    <div
                        className={`project__edit--role__board--component__head ${
                            page ? "" : "project__edit--role__board--component__head--choise"
                        }`}
                        onClick={changeTab}
                    >
                        Доступ к канбан доскам
                    </div>
                </div>
                {page ? (
                    <ParticipantRights
                        userRole={userRole}
                        boardsData={boardsData}
                        idRoleToEdit={roleIdG}
                        personId={personRole}
                        setUserRoleCallback={(userRole) => setUserRole(userRole)}
                        setBoardsDataCallback={(boardsData) => setBoardsData(boardsData)}
                    />
                ) : (
                    <div
                        className="project__edit--role__board--component__edit"
                        style={{ overflow: "auto", marginTop: "10px" }}
                    >
                        <div className="restrict__access--list__board--head">Канбан доски</div>
                        <div className="project__edit--role__board--component__block">
                            {boardsData?.boards.map((board) => (
                                <div>
                                    <div className="restrict__access--list__board">
                                        <div className="restrict__access--list__board--desc">{board.name}</div>
                                        <div className="restrict__access--list__board--chek">
                                            <div
                                                className={`restrict__access--list__board--chek__size ${
                                                    checkSystemRole() === true
                                                        ? "project__edit--role__board--access__permissions--input__system--role"
                                                        : ""
                                                }`}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={
                                                        checkSystemRole() === true
                                                            ? true
                                                            : board.personRoleIds?.includes(
                                                                    userRole!.roles[roleIdG].personRoleId
                                                                )
                                                              ? false
                                                              : true
                                                    }
                                                    onClick={() =>
                                                        checkSystemRole() !== true
                                                            ? onCheckEvent(board.id)
                                                            : showToast(
                                                                  "Доступ ко всем доскам проекта выдан в рамках системной роли!"
                                                              )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="restrict__access--list__columns">
                                        {board.columns
                                            .sort((a, b) => a.state - b.state)
                                            .map((column) => (
                                                <div
                                                    className={
                                                        board.personRoleIds?.includes(
                                                            roleEdit!.roles[roleIdG].personRoleId
                                                        )
                                                            ? "restrict__access--list__column"
                                                            : "restrict__access--list__column restrict__access--list__column--gray"
                                                    }
                                                >
                                                    <div className="restrict__access--list__column--name">
                                                        {column.name}
                                                    </div>
                                                    <div className="restrict__access--list__column--chek">
                                                        <div
                                                            className={`restrict__access--list__board--chek__size ${
                                                                checkSystemRole() === true
                                                                    ? "project__edit--role__board--access__permissions--input__system--role"
                                                                    : ""
                                                            }`}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={
                                                                    checkSystemRole() === true
                                                                        ? true
                                                                        : column.personRoleIds?.includes(
                                                                                roleEdit!.roles[roleIdG]!.personRoleId
                                                                            )
                                                                          ? false
                                                                          : true
                                                                }
                                                                onClick={() =>
                                                                    checkSystemRole() !== true
                                                                        ? addColumnAccess(
                                                                              column.id,
                                                                              !!column.personRoleIds?.includes(
                                                                                  roleEdit!.roles[roleIdG]!.personRoleId
                                                                              )
                                                                          )
                                                                        : showToast(
                                                                              "Доступ ко всем колонкам проекта выдан в рамках системной роли!"
                                                                          )
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <div className="project__edit--role__board__buttons">
                    <div className="project__edit--role__board__buttons--add">
                        <button data-testid="button-project_edit_user_permissions_form-save" onClick={saveExclude}>
                            Сохранить
                        </button>
                    </div>
                    <div className="project__edit--role__board__buttons--exit">
                        <button data-testid="button-project_edit_user_permissions_form-cancel" onClick={closeFunc}>
                            Отмена
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectEditRoleBoard;
